import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AnalyticsService } from './shared/posthug-analytics/analytics.service';
import { AppUpdatesService } from './updates/service/app-updates.service';

@Component({
  selector: 'app-root',
  template: `
    <gc-snackbars-container class="gc-theme-light"></gc-snackbars-container>
    <app-toasts-container></app-toasts-container>
    <ipo-alerts-container></ipo-alerts-container>
    <app-feedback-alert></app-feedback-alert>
    <router-outlet></router-outlet>
    @if ((showFooter$ | async)!) {
      <app-update-footer></app-update-footer>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private updatesService: AppUpdatesService,
    private analyticsService: AnalyticsService,
  ) {}

  showFooter$: Observable<boolean>;

  ngOnInit() {
    this.showFooter$ = this.updatesService.getUpdatesAvailable$();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const analytics =
          this.router.currentNavigation()?.extras?.state?.analytics;
        if (analytics === undefined || analytics === true) {
          this.analyticsService.logPageView(event.url);
        }
      }
    });
  }
}
